module.exports = {
  CameraFrame: {
    setSettings: async () => {},
    showPreview: async () => {},
    hidePreview: async () => {},
    destroy: async () => {},
    flipCamera: async () => {},
    setCamera: async () => {},
    availableCameras: async () => ({ cameras: [] }),
    moveCameraView: async () => {},
    zoom: async () => {},
    startRecording: async () => {},
    stopRecording: async () => ({ videoURL: '' }),
    captureImage: async () => ({ img: '' }),
    addListener: async () => ({
      remove: async () => {},
    }),
    removeAllListeners: async () => {},
    checkPermissions: async () => ({ camera: 'denied' }),
    requestPermissions: async () => ({ camera: 'denied' }),
  }
};